export default "__VITE_PUBLIC_ASSET__f31d162c__"